import { createLayerComponent } from '@react-leaflet/core';
import * as EL from 'esri-leaflet';

const createEsriFeatureLayer = (props, context) => {
  const { popupFields = [] } = props;  // get popupFields from props, default empty array
  const clonedProps = { ...props };

  const onEachFeature = (feature, layer) => {
    const props = feature.properties || feature.attributes || {};

    // Build popup content dynamically based on popupFields array
    let popupContent = '<div>';
    popupFields.forEach(field => {
      const value = props[field] ?? 'N/A';
      popupContent += `<p>${value}</p>`;
    });
    popupContent += '</div>';

    layer.bindPopup(popupContent);
  };

  clonedProps.onEachFeature = onEachFeature;

  const layer = EL.featureLayer(clonedProps);

  return {
    instance: layer,
    context: { ...context, layer }
  };
};

const updateEsriFeatureLayer = (layer, props, prevProps) => {
  if (props.style !== prevProps.style) {
    layer.setStyle(props.style);
  }
};

export const EsriFeatureLayer = createLayerComponent(
  createEsriFeatureLayer,
  updateEsriFeatureLayer
);
